// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, nav {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

nav {
  z-index: 99;
  width: 100%;
  background: #0b2d71;
}

nav .cvx-navbar-wrapper {
  position: relative;
  height: 45px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cvx-navbar-wrapper .cvx-navbar-nav-links {
  display: flex;
  padding: 0;
  margin: 0;
  height: 100%;
}

.cvx-navbar-nav-links li {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.cvx-navbar-nav-links li a {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 1rem 2rem 1rem 2rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.cvx-navbar-nav-links li a:hover {
  background: #0066b2;
}

.cvx-navbar-nav-links .cvx-navbar-mobile-item {
  display: none;
}

.cvx-navbar-nav-links .cvx-navbar-drop-menu {
  margin: 0;
  padding: 0;
  position: absolute;
  background: #0066b2;
  width: auto;
  line-height: 45px;
  top: 85px;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  z-index: 99999999;
}

.cvx-navbar-nav-links li:hover .cvx-navbar-drop-menu,
.cvx-navbar-nav-links li:hover .cvx-navbar-mega-box {
  top: 45px;
  opacity: 1;
  visibility: visible;
}

.cvx-navbar-drop-menu li a {
  width: 100%;
  display: block;
  padding: 10px;
  font-weight: 400;
  border-radius: 0px;
}

.cvx-navbar-drop-menu li a:hover {
  background: #0b2d71;
}

.cvx-navbar-content .cvx-navbar-row img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cvx-navbar-content .cvx-navbar-row header {
  color: #dbdcdd;
  font-size: 16px;
  font-weight: 500;
}

.cvx-navbar-wrapper .cvx-navbar-btn {
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  display: none;
}

.cvx-navbar-wrapper .cvx-navbar-btn.cvx-navbar-close-btn {
  position: absolute;
  right: 30px;
  top: 10px;
}

nav input {
  display: none;
}

.cvx-navbar-body-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 30px;
}

.cvx-navbar-body-text div {
  font-size: 45px;
  font-weight: 600;
}

.cvx-navbar-disabled-link {
  pointer-events: none; /* Deshabilita la interacción */
  cursor: default; /* Cambia el cursor a su estado por defecto */
  color: inherit; /* Mantiene el color del enlace */
  text-decoration: none; /* Opcional: elimina el subrayado */
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
